import { render, staticRenderFns } from "./VenueOrders.vue?vue&type=template&id=d3abd39a&scoped=true&"
import script from "./VenueOrders.vue?vue&type=script&lang=js&"
export * from "./VenueOrders.vue?vue&type=script&lang=js&"
import style0 from "./VenueOrders.vue?vue&type=style&index=0&id=d3abd39a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3abd39a",
  null
  
)

export default component.exports